import React from 'react'
import AdminUsersClient from '../../components/AdminUsersClient'
import { supabase } from "../../utils/supabase/client"

async function getAllUsers() {
  const { data: users, error } = await supabase
    .from('profiles')
    .select('id, first_name, last_name, email, role, created_at, updated_at')
    .order('created_at', { ascending: false })
  if (error) throw error
  return users || []
}

export default function UsersPage() {
  const [users, setUsers] = React.useState<any[]>([])
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState<string | null>(null)

  React.useEffect(() => {
    getAllUsers()
      .then(setUsers)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <div className="p-8 text-center">Loading...</div>
  if (error) return <div className="p-8 text-center text-red-500">{error}</div>

  return (
    <div>
      <h1 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100">User Management</h1>
      <p className="text-lg text-muted-foreground mt-2">
        View and manage all users on the platform.
      </p>
      <div className="mt-8">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md">
          <AdminUsersClient users={users} />
        </div>
      </div>
    </div>
  )
} 